<template>
	<div>
		 <a class='dropdown-trigger' :data-target="'dropdown' + uid"><span class="material-icons star" :style="{color: currentcolor}">fiber_manual_record</span></a>
		<ul :id="'dropdown' + uid" class='dropdown-content'>
		<li v-for="c in colors"><span class="material-icons star" :style="{color: c}" v-on:click="changeColor(c)">fiber_manual_record</span></li>
		</ul>
	</div>
</template>
<script>
import axios from 'axios';
import _ from 'lodash';
export default {
  data: function () {
    return {
    	uid: _.uniqueId("colorselector"),
    	colors: [ "white", "red", "green", "orange", "blue", "yellow", "violet", "gray", "black" ],
    	currentcolor: this.color
    }
  },
  mounted: function(){
  	var elems = document.querySelectorAll('.dropdown-trigger');
    var instances = M.Dropdown.init(elems, {});
  },
  methods: {
  	changeColor: function(c){
  		this.currentcolor = c;
  		this.$emit('colorSelected', c);
  	}
  },
  props: { color: String},
  computed: {
   
  },
  
}
</script>
<style scoped>
div {
  margin-left: auto;
  left: auto;
  right: auto;
  line-height: 2;
}
.star{
    -webkit-text-stroke: black;
    -webkit-text-stroke-width: 1px;
    user-select: none;
}
</style>